import React from "react";

import { Route, Redirect } from "react-router-dom";
import { useParams } from "react-router-dom";
function ProtectedRoute({ component: Component, ...restOfProps }) {
  // const navigate = useNavigate();
  let isAuthenticated = null;
  if (localStorage.getItem("token") == null || undefined) {
    isAuthenticated = false;
  } else isAuthenticated = true;

  return (
    <Route
      {...restOfProps}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
}
export default ProtectedRoute;
